exports.components = {
  "component---src-components-templates-page-tsx": () => import("./../../../src/components/templates/Page.tsx" /* webpackChunkName: "component---src-components-templates-page-tsx" */),
  "component---src-components-templates-post-tsx": () => import("./../../../src/components/templates/Post.tsx" /* webpackChunkName: "component---src-components-templates-post-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */)
}

